module.exports = __webpack_public_path__ + "static/DeChartMobile-ce886730be12f77827f8321b553f3998.svg";